import React from 'react';
import CommonDatePicker from '../../Components/Datepicker/datepicker';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import PropTypes from 'prop-types';
import { DATA_CONFIGURATION } from '../../Constants/strings';
import ButtonComponent from '../../Components/Button/button';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const dataUploadConfig = ({
  header,
  isEdit,
  startDateInput,
  endDateInput,
  startDateError,
  endDateError,
  isChecked,
  hasAccess,
  handleEdit,
  handleSetButton,
  handleStartDate,
  handleCheckBoxChange,
  handleEndDate,
  btnId,
}) => {

  return (
    <div className="data-upload-container">
      <h2 className="title">{header}</h2>
      <div className="date-fields-container">
        <div className={`date-upload-field ${isEdit ? 'is-edit' : ''}`}>
          <CommonDatePicker
            isDisabled={!isEdit}
            textCss="effort-upload-start-date-field"
            label={DATA_CONFIGURATION.FROM}
            placeholder={DATA_CONFIGURATION.SELECT_TIMESTAMP}
            value={startDateInput ? dayjs(startDateInput) : null}
            onChange={(date) =>
              handleStartDate({
                name: 'startDate',
                value: date,
              })
            }
            id={'add-start-date-text'}
            className="custom-calender"
          />
          {startDateError && (
            <div className={'config-upload-error'}>
              <small>{startDateError}</small>
            </div>
          )}
        </div>
        <div className='field-and-button'>
          <div className={`date-upload-field ${isEdit ? 'is-edit' : ''}`}>
            <CommonDatePicker
              isDisabled={!isEdit}
              textCss="input-field"
              label={DATA_CONFIGURATION.TO}
              placeholder={DATA_CONFIGURATION.SELECT_TIMESTAMP}
              value={endDateInput ? dayjs(endDateInput) : null}
              onChange={(date) =>
                handleEndDate({
                  name: 'endDate',
                  value: date,
                })
              }
              id={'add-end-date-text'}
              className="custom-calender"
            />
            {endDateError && (
              <div className={'config-upload-error'}>
                <small>{endDateError}</small>
              </div>
            )}
          </div>
          {isEdit ? (
            <div className="config-set-button">
              <ButtonComponent
                disabled={!hasAccess('update')}
                label={'Set'}
                variant="contained"
                onClick={handleSetButton}
                btnCss={`set-button ${endDateError || startDateError ? 'is-error' : ''}`}
                id={btnId}
              ></ButtonComponent>
            </div>
          ) : (
            <button onClick={handleEdit} className={hasAccess('update') ? 'config-edit-icon' : 'edit-display-none'}
            >
              <img src={EditIcon} alt="Edit" />
            </button>
          )}
        </div>
      </div>
      {isEdit && <div className='config-checkbox'>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleCheckBoxChange}
              checked={isChecked}
            />
          }
        />
        <span className='span'>{DATA_CONFIGURATION.CHECKBOX_CONTENT}</span>
      </div>}
    </div>
  );
};
dataUploadConfig.propTypes = {
  header: PropTypes.string,
  isEdit: PropTypes.bool,
  startDateInput: PropTypes.string,
  endDateInput: PropTypes.string,
  startDateError: PropTypes.string,
  endDateError: PropTypes.string,
  isChecked: PropTypes.bool,
  hasAccess: PropTypes.func,
  handleEdit: PropTypes.func,
  handleSetButton: PropTypes.func,
  handleStartDate: PropTypes.func,
  handleCheckBoxChange: PropTypes.func,
  handleEndDate: PropTypes.func,
  btnId: PropTypes.string,
};

export default dataUploadConfig;
